<template>
  <VeeForm ref="etabForm" v-slot="{ pristine }" @submit="onSave">
    <section>
      <ExtraTipbox v-if="readonly" class="text-left">
        <h4>{{ $t("ETAB.PAGES.ADMIN_FOLDER.FORMS.@CONTACT_US_TO_UPDATE") }}</h4>
      </ExtraTipbox>
      <Field
        :ref="IEtabAdminFolder.socialReason"
        v-slot="{ errors, field, value }"
        v-model="internalAdminFolder[IEtabAdminFolder.socialReason]"
        as="div"
        :name="$filters.formLabelValidation($t('ETAB.PAGES.ADMIN_FOLDER.FORMS.@ETAB_NAME'))"
        :rules="{ required: true }"
      >
        <QInput
          v-bind="field"
          :model-value="value"
          :label="$t('ETAB.PAGES.ADMIN_FOLDER.FORMS.@ETAB_NAME')"
          :name="IEtabAdminFolder.socialReason"
          :disable="readonly"
          type="text"
          class="q-mb-xl"
          :error="errors.length > 0"
          :error-message="errors[0]"
          hide-bottom-space
          :hint="$t('ETAB.PAGES.ADMIN_FOLDER.FORMS.@ETAB_NAME_HINT')"
        />
      </Field>
      <Field
        :ref="IEtabAdminFolder.siret"
        v-slot="{ errors, field, value }"
        v-model="internalAdminFolder[IEtabAdminFolder.siret]"
        :name="$filters.formLabelValidation($t('ETAB.PAGES.ADMIN_FOLDER.FORMS.@SIRET'))"
        :rules="{ min: 9, max: 14, regex: /^(U)?[0-9]+/, required: true }"
      >
        <QInput
          v-bind="field"
          :model-value="value"
          :label="$t('ETAB.PAGES.ADMIN_FOLDER.FORMS.@SIRET')"
          :name="IEtabAdminFolder.siret"
          :disable="readonly"
          type="text"
          :error="errors.length > 0"
          :error-message="errors[0]"
        />
      </Field>
      <Field
        :ref="IEtabAdminFolder.vat"
        v-slot="{ errors, field, value }"
        v-model.trim="internalAdminFolder[IEtabAdminFolder.vat]"
        as="div"
        :name="$filters.formLabelValidation($t('ETAB.PAGES.ADMIN_FOLDER.FORMS.@VAT'))"
        :rules="{ required: true }"
      >
        <QInput
          v-bind="field"
          :model-value="value"
          :label="$t('ETAB.PAGES.ADMIN_FOLDER.FORMS.@VAT')"
          :name="IEtabAdminFolder.vat"
          :disable="readonly"
          type="text"
          class="q-mb-lg"
          :hint="$t('ETAB.PAGES.ADMIN_FOLDER.FORMS.@VAT_HINT')"
          :error="errors.length > 0"
          :error-message="errors[0]"
        />
      </Field>
      <Field
        :ref="IEtabAdminFolder.address"
        v-slot="{ errors, field, value }"
        v-model="internalAdminFolder[IEtabAdminFolder.address]"
        as="div"
        :name="$filters.formLabelValidation($t('ETAB.PAGES.ADMIN_FOLDER.FORMS.@BILLING_ADDRESS'))"
        :rules="{ required: true }"
      >
        <QInput
          v-bind="field"
          :model-value="value"
          :label="$t('ETAB.PAGES.ADMIN_FOLDER.FORMS.@BILLING_ADDRESS')"
          :name="IEtabAdminFolder.address"
          :disable="readonly"
          type="text"
          :error="errors.length > 0"
          :error-message="errors[0]"
        />
      </Field>
      <div class="row q-col-gutter-lg">
        <div class="col-6">
          <Field
            :ref="IEtabAdminFolder.postalCode"
            v-slot="{ errors, field, value }"
            v-model="internalAdminFolder[IEtabAdminFolder.postalCode]"
            :name="$filters.formLabelValidation($t('ETAB.PAGES.ADMIN_FOLDER.FORMS.@BILLING_POSTAL_CODE'))"
            :rules="{ required: true, integer: true, length: 5 }"
          >
            <QInput
              v-bind="field"
              :model-value="value"
              :label="$t('ETAB.PAGES.ADMIN_FOLDER.FORMS.@BILLING_POSTAL_CODE')"
              :name="IEtabAdminFolder.postalCode"
              :disable="readonly"
              type="number"
              :error="errors.length > 0"
              :error-message="errors[0]"
            />
          </Field>
        </div>
        <div class="col-6">
          <Field
            :ref="IEtabAdminFolder.city"
            v-slot="{ errors, field, value }"
            v-model="internalAdminFolder[IEtabAdminFolder.city]"
            :disable="readonly"
            :name="$filters.formLabelValidation($t('ETAB.PAGES.ADMIN_FOLDER.FORMS.@BILLING_CITY'))"
            :rules="{ required: true }"
          >
            <QInput
              v-bind="field"
              :model-value="value"
              :label="$t('ETAB.PAGES.ADMIN_FOLDER.FORMS.@BILLING_CITY')"
              :name="IEtabAdminFolder.city"
              :disable="readonly"
              type="text"
              :error="errors.length > 0"
              :error-message="errors[0]"
            />
          </Field>
        </div>
        <div class="col-6">
          <Field
            :ref="IEtabAdminFolder.country"
            v-slot="{ errors, field, value }"
            v-model="internalAdminFolder[IEtabAdminFolder.country]"
            :name="$filters.formLabelValidation($t('ETAB.PAGES.ADMIN_FOLDER.FORMS.@BILLING_COUNTRY'))"
            :rules="{ required: true }"
          >
            <QInput
              v-bind="field"
              :model-value="value"
              :label="$t('ETAB.PAGES.ADMIN_FOLDER.FORMS.@BILLING_COUNTRY')"
              :name="IEtabAdminFolder.country"
              :disable="readonly"
              type="text"
              :error="errors.length > 0"
              :error-message="errors[0]"
            />
          </Field>
        </div>
      </div>
      <Field
        :ref="IEtabAdminFolder.email"
        v-slot="{ errors, field, value }"
        v-model="internalAdminFolder[IEtabAdminFolder.email]"
        :name="$filters.formLabelValidation($t('ETAB.PAGES.ADMIN_FOLDER.FORMS.@BILLING_CONTACT_MAIL'))"
        :rules="{ required: true, email: true }"
      >
        <QInput
          v-bind="field"
          :model-value="value"
          :label="$t('ETAB.PAGES.ADMIN_FOLDER.FORMS.@BILLING_CONTACT_MAIL')"
          :name="IEtabAdminFolder.email"
          :disable="readonly"
          class="q-mb-xl"
          type="text"
          :hint="$t('ETAB.PAGES.ADMIN_FOLDER.FORMS.@BILLING_CONTACT_MAIL_HINT')"
          :error="errors.length > 0"
          :error-message="errors[0]"
        />
      </Field>
    </section>
    <div class="full-width row justify-center q-mb-lg q-gutter-md">
      <QBtn
        v-if="!readonly"
        type="submit"
        color="secondary"
        :label="$t('ETAB.PAGES.ADMIN_FOLDER.FORMS.@SAVE_FOLDER')"
        class="full-width"
        no-caps
        :disable="pristine"
      />
    </div>
    <AdminFolderConfirmModal v-model:opened="openedAdminFolderConfirmModal" :etab-admin-folder="internalAdminFolder" @save-folder="saveFolder" />
  </VeeForm>
</template>
<script>
  import { Form as VeeForm, Field } from "vee-validate";
  import AdminFolderConfirmModal from "@etab/components/account/AdminFolderConfirm.modal.vue";
  import { EtabAdminFolderModel, IEtabAdminFolder } from "@core/models";

  const COUNTRY_BY_DEFAULT = "France";

  export default {
    components: {
      Field,
      VeeForm,
      AdminFolderConfirmModal,
      VeeForm,
      Field,
    },
    props: {
      etabAdminFolder: {
        type: Object,
        default: () => ({}),
      },
    },
    emits: ["saveFolder"],
    data() {
      return {
        openedAdminFolderConfirmModal: false,
        readonly: false,
        internalAdminFolder: new EtabAdminFolderModel(),
      };
    },
    created() {
      this.IEtabAdminFolder = IEtabAdminFolder;
      this.initForm();
    },
    methods: {
      initForm() {
        this.internalAdminFolder = new EtabAdminFolderModel(this.etabAdminFolder);
        if (this.internalAdminFolder.getHasAdminInfo()) {
          this.readonly = true;
        }
        if (!this.internalAdminFolder[IEtabAdminFolder.country]) {
          this.internalAdminFolder[IEtabAdminFolder.country] = COUNTRY_BY_DEFAULT;
        }
      },
      async onSave() {
        this.openedAdminFolderConfirmModal = true;
      },
      saveFolder() {
        this.$emit("saveFolder", { adminFolder: this.internalAdminFolder });
        this.openedAdminFolderConfirmModal = false;
      },
    },
  };
</script>
